/** @format */

import React from 'react';

interface CardBoxImageInterface {
    img: string;
}

const CardBoxImage = (props: CardBoxImageInterface): React.ReactElement => {
    return <div></div>;
};

export default CardBoxImage;
